import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42ba4c11"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-d-flex p-mt-2 p-mb-2" }
const _hoisted_2 = { class: "form-check" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "onSetSelfPick"
}, "รับสินค้าด้วยตัวเอง", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-my-2" }, "ที่อยู่ในการจัดส่ง", -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 0,
  class: "text-error f-size-14"
}
const _hoisted_8 = { class: "p-d-flex p-mt-2" }
const _hoisted_9 = { class: "form-check" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "sameReceiptCheckbox"
}, "ใช้ที่อยู่เดียวกับที่อยู่ในการจัดส่ง", -1))
const _hoisted_11 = { class: "p-d-flex p-mt-2" }
const _hoisted_12 = { class: "form-check" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "getTaxReceiptCheckbox"
}, "ออกใบกำกับภาษี", -1))
const _hoisted_14 = {
  key: 2,
  class: "p-mt-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AddressUserForm = _resolveComponent("AddressUserForm")!
  const _component_AddressListPanel = _resolveComponent("AddressListPanel")!
  const _component_ShippingAddressDetailForm = _resolveComponent("ShippingAddressDetailForm")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_BillingAddressDetailForm = _resolveComponent("BillingAddressDetailForm")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_component_AddressUserForm, {
        v: _ctx.v.userInfo,
        onOnCalculateShippingCost: _ctx.onCalculateShippingCost
      }, null, 8, ["v", "onOnCalculateShippingCost"])
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isSelfPick) = $event)),
          type: "checkbox",
          class: "form-check-input",
          id: "onSetSelfPickCheckbox",
          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('onSetSelfPick', _ctx.isSelfPick)))
        }, null, 544), [
          [_vModelCheckbox, _ctx.isSelfPick]
        ]),
        _hoisted_3
      ])
    ]),
    (_ctx.sessionId)
      ? (_openBlock(), _createBlock(_component_AddressListPanel, {
          key: 0,
          sessionId: _ctx.sessionId,
          v: _ctx.v,
          isSelfPick: _ctx.isSelfPick,
          onOnCalculateShippingCost: _ctx.onCalculateShippingCost,
          onSetSelfPickupAddress: _ctx.setSelfPickupAddress
        }, null, 8, ["sessionId", "v", "isSelfPick", "onOnCalculateShippingCost", "onSetSelfPickupAddress"]))
      : _createCommentVNode("", true),
    (!_ctx.sessionId)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _hoisted_4,
          (!_ctx.isSelfPick)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_ShippingAddressDetailForm, {
                  v: _ctx.v.shippingAddress
                }, null, 8, ["v"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", null, [
                  _createVNode(_component_Textarea, {
                    modelValue: _ctx.selfPickupAddress,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selfPickupAddress) = $event)),
                    onKeyup: _ctx.setSelfPickupAddressDetail,
                    rows: "3",
                    class: _normalizeClass(["w-100", !_ctx.selfPickupAddress && 'border-red'])
                  }, null, 8, ["modelValue", "onKeyup", "class"])
                ]),
                (!_ctx.selfPickupAddress)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, " กรุณากรอกที่อยู่ในการรับสินค้า "))
                  : _createCommentVNode("", true)
              ])),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.transaction.buyerInfo.sameAddress) = $event)),
                  type: "checkbox",
                  class: "form-check-input",
                  id: "sameReceiptCheckbox"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.transaction.buyerInfo.sameAddress]
                ]),
                _hoisted_10
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.transaction.buyerInfo.userInfo.isRequestTaxInvoice) = $event)),
                  type: "checkbox",
                  class: "form-check-input",
                  id: "getTaxReceiptCheckbox"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.transaction.buyerInfo.userInfo.isRequestTaxInvoice]
                ]),
                _hoisted_13
              ])
            ])
          ]),
          (
          !_ctx.transaction.buyerInfo.sameAddress ||
          _ctx.transaction.buyerInfo.userInfo.isRequestTaxInvoice ||
          (_ctx.transaction.buyerInfo.sameAddress &&
            _ctx.transaction.buyerInfo.userInfo.isRequestTaxInvoice)
        )
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createVNode(_component_BillingAddressDetailForm, {
                  v: _ctx.v.billingAddress
                }, null, 8, ["v"])
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ]))
}